import { Schemas } from '~/api/gen'
import { MetaData } from '~/components/Meta'
import { wearUrl } from '~/features/shared/domain/wearUrl'
import { getUserNameForSeo } from '~/lib/getUserNameForSeo'

export const getMetadata = ({
  member,
  folderName,
  folderId,
  firstImageUrl,
  noIndex = false,
}: {
  member: {
    nick_name: string
    user_name: string
    is_wearista: boolean
    is_shop_clerk: boolean
    shop?: Schemas.shop | null
  }
  folderName: string
  folderId: number
  firstImageUrl?: string
  noIndex?: boolean
}): MetaData => {
  const userName = getUserNameForSeo({
    nickname: member.nick_name,
    wearista: member.is_wearista,
    shopClerk: member.is_shop_clerk,
    shopName: member.shop?.name,
  })
  return {
    title: `「${folderName}」${userName}のお気に入りフォルダ`,
    description: `${userName}のお気に入りフォルダ「${folderName}」です。WEARはモデル・俳優・ショップスタッフなどの着こなしをチェックできるファッションコーディネートサイトです。`,
    appUrl: `wear2020://wear.jp/favorite/${folderId}/`,
    ogImageUrl: firstImageUrl,
    robots: !noIndex,
    url: wearUrl(`/${member.user_name}/favorite/${folderId}/`).href,
  }
}
